const useSelectedProjectsStore = defineStore('selectedProjects', () => {
  const value = ref<string[]>([])

  return {
    value,
  }
}, {
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
})

export default useSelectedProjectsStore
